import React, { Component } from "react";

import PropTypes from "prop-types";
import ValidatorUtils from "../../../../utils/ValidatorUtils";
import { injectIntl } from "react-intl";

/**
 * The component which shows validation errors on survey-view.
 */
class QuestionValidation extends Component {
  render() {
    let { validation, validator, intl, showOnlyError, questionType, initialTextLength } = this.props;
    let element = null;
    if (validation || validator) {
      let message = ValidatorUtils.prepareValidationMessage(validator, validation);
      const configuredLengthValue = validator?.props?.length;
      const configuredLength = Number(configuredLengthValue);
      const initialLengthInvalid =
        !validation &&
        initialTextLength !== null &&
        initialTextLength !== undefined &&
        configuredLengthValue !== "" &&
        configuredLengthValue !== null &&
        configuredLengthValue !== undefined &&
        Number.isFinite(configuredLength) &&
        initialTextLength > configuredLength;
      const invalid = validation ? !validation.isOk : initialLengthInvalid;
      let show = !showOnlyError || invalid;
      if (message !== null && show) {
        element = (
          <span className={`${questionType} ${invalid ? "text-danger" : "text-success"}`}>
            {initialTextLength !== null && initialTextLength !== undefined
              ? intl.formatMessage(
                  { id: "app.validation.initialLengthMessage" },
                  {
                    text: message.values.currentLength === 0 ? initialTextLength : message.values.currentLength,
                    length: message.values.length
                  }
                )
              : intl.formatMessage(message.format, message.values)}
          </span>
        );
      }
    }
    return element;
  }
}

QuestionValidation.propTypes = {
  validation: PropTypes.object,
  validator: PropTypes.object,
  intl: PropTypes.object,
  showOnlyError: PropTypes.bool,
  questionType: PropTypes.string,
  initialTextLength: PropTypes.number
};

export default injectIntl(QuestionValidation);
